import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { PlainLinkComponent } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { WalletHelpComponent } from './wallet-help/wallet-help.component';
import { WalletSelectionDropdownComponent } from './wallet-selection-dropdown.component';

@NgModule({
    imports: [CommonModule, PlainLinkComponent, IconCustomComponent, CurrencyPipe],
    declarations: [WalletSelectionDropdownComponent, WalletHelpComponent],
    exports: [WalletSelectionDropdownComponent],
})
export class AccountBalanceModule {}
